module.exports = __webpack_public_path__ + "assets/img/title-df2bf140.png";